import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Tooltip} from "react-tooltip";
import {setPaymentModal} from "../../../Store/Slice/techsbookSlice";
import useGetPaymentList from "../../../Global/Api/Account/getPaymentListApi";
import Button from "../../../UI/Button";
import Popup from "../../Popup";
import useDeletePaymentMethodApi from "../../../Global/Api/Settings/deletePaymentMethodApi";
import useGetStripeKeyApi from "../../../Global/Api/Account/getStripeKeyApi";
import "./index.scss";

export default function PaymentMethod() {
  const dispatch = useDispatch();
  const getPaymentList = useGetPaymentList();
  const deleteApi = useDeletePaymentMethodApi();
  const {paymentList, paymentModal} = useSelector(
    (state) => state.rootReducer.techsbookSlice
  );
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [itemInfo, setItemInfo] = useState(null);

  useEffect( () => {
    if (!paymentModal) {
      getPaymentList.get();
    }
  }, [paymentModal]);

  const openDeleteModal = (item) => {
    setShowDeleteModal(true)
    setItemInfo(item)
  }

  const closeDeleteModal = () => {
    setShowDeleteModal(false)
    setItemInfo(null)
  }

  const handleDelete = (id) => {
    deleteApi.send({id}, closeDeleteModal, getPaymentList.get);
  };


  return (
    <div className="payment">
      {showDeleteModal && (
        <Popup
          title='Confirm your action'
          closePopup={closeDeleteModal}
        >
          <div className="technician__popup">
            <p className="technician__popup-text">
              Are you sure you want to delete the payment method?
            </p>
            <div className="technician__popup-btns">
              <div className="technician__popup-btn technician__popup-btn_cancel">
                <Button
                  text='Cancel'
                  onClick={closeDeleteModal}
                />
              </div>
              <div className="technician__popup-btn technician__popup-btn_red">
                <Button
                  onClick={() => {
                    handleDelete(itemInfo.id)
                  }}
                  text='Delete'
                />
              </div>
            </div>
          </div>
        </Popup>
      )}
      <div className="payment__head">
        <p className="payment__title">Payment method</p>
        <div
          onClick={() => {
            dispatch(setPaymentModal(true));
          }}
          className="payment__btn"
        >
          <span>
            <img src="../../assets/icons/plus.svg" alt="plus"/>
          </span>
          Add new card
        </div>
      </div>
      <div className='payment-list'>
        {paymentList?.length === 0 ? (
            <div>
              <div>
                <img src="/assets/images/payment-empty.svg" alt=""/>
              </div>
              <p className="technicians-empty-text">No Saved Cards</p>
            </div>
          ) :
          paymentList?.map((item) => (
            <div key={item?.id} className="payment__item">
              <div className="payment__item-left">
                <p className="payment__item-number">
                  {item?.payment_method_data?.brand ?? 'visa'}: **** **** **** {item?.payment_method_data?.last4}
                </p>
                <p className="payment__item-date">
                  Exp.date:{" "}
                  {item?.payment_method_data?.exp_month > 9
                    ? item?.payment_method_data?.exp_month
                    : "0" + item?.payment_method_data?.exp_month}
                  /{item?.payment_method_data?.exp_year}
                </p>
              </div>
              <div className="payment__item-right">
                {!item?.can_delete ? (
                  <div data-tooltip-id="payment-disabled"
                       data-tooltip-content={'You are unable to remove this payment method due to pending payments associated with it'}
                       onClick={() => {
                         if(item?.can_delete) {
                           openDeleteModal(item)
                         }
                       }}
                       className={`payment__item-btn ${!item?.can_delete ? 'payment__item-btn_disable' : ''}`}>
                <span>
                  <img src="../../assets/icons/trash.svg" alt="trash"/>
                </span>
                    <div className="payment__item-right-tooltip">
                      <Tooltip place="bottom-end" id="payment-disabled"/>
                    </div>
                  </div>
                ) : (
                  <div
                    onClick={() => {
                      if(item?.can_delete) {
                        openDeleteModal(item)
                      }
                    }}
                    className={`payment__item-btn ${!item?.can_delete ? 'payment__item-btn_disable' : ''}`}>
                <span>
                  <img src="../../assets/icons/trash.svg" alt="trash"/>
                </span>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
